
export const teamMembersData = [
    {
        name: 'Nicolas Breedlove',
        image: '/img/team/nicolas1.webp',
        image2: '/img/team/nicolas2.webp',
        image3: '/img/team/nicolas3.webp',
        title: 'CEO',
        bio: '<p>Since joining the company in 2006, Nicolas Breedlove has led with a vision for innovation and growth. As a child, he loved exploring wooden castles and bridges on the playground, a sense of adventure he carries into his work. Outside the office, Nicolas enjoys writing, brainstorming new business ideas, and experiencing life’s adventures with his family.</p>'
    },
    {
        name: 'Jared Darlington',
        image: '/img/team/JaredDarlington1.webp',
        image2: '/img/team/JaredDarlington2.webp',
        image3: '/img/team/JaredDarlington3.webp',
        title: 'Director of Sales & Support',
        title2: '',
        bio: '<p>Jared joined the team in 2024, bringing a passion for helping others and fostering strong relationships. The climbers were his favorite part of the playground as a kid, which inspired his love for adventure and exploration. Outside of work, Jared enjoys traveling with his wife to see live music and staying active by playing pickleball.</p>'
    },
    {
        name: 'Lindsay Coenen',
        image: '/img/team/lindsay1.webp',
        image2: '/img/team/lindsay2.webp',
        image3: '/img/team/lindsay3.webp',
        title: 'Senior Account Liaison',
        title2: '',
        bio: '<p>Since joining in 2021, Lindsay Coenen has brought enthusiasm and dedication to her role. Growing up, she loved any playground equipment she could climb. In her free time, she travels, attends concerts, and relaxes at home with her two cats.</p>'
    },
    {
        name: 'Chris Lance',
        image: '/img/team/ChrisLance1.webp',
        image2: '/img/team/ChrisLance2.webp',
        image3: '/img/team/ChrisLance3.webp',
        title: 'Director of Operations',
        title2: '',
        bio: '<p>Chris joined the team in 2024, bringing strong leadership and a collaborative spirit to the company. As a child, he loved the excitement of tube slides, a passion for fun and adventure that continues today. Chris enjoys traveling, hiking, and spending quality time outdoors with his wife and kids. He’s also passionate about boating and loves being on, in, or near the water whenever possible.</p>'
    },
    {
        name: 'Ben White',
        image: '/img/team/ben-white1.webp',
        image2: '/img/team/ben-white2.webp',
        image3: '/img/team/ben-white3.webp',
        title: 'Human Resource Manager',
        title2: '',
        bio: '<p>Ben joined the team in 2024, bringing creativity and enthusiasm to the company’s HR initiatives. As a child, he loved conquering the monkey bars, embracing the thrill of swinging like a tiny adventurer. A self-proclaimed extreme DIY-er, Ben mows the lawn with Formula 1 precision, devours books as his secret superpower, and spoils his rescue pups like royalty. He’s also a talented baker, crafting treats that could cause a sugar rush at first glance, and is always coming up with playful ways to keep his spouse on their toes. For Ben, life is all about embracing the chaos and having fun along the way!</p>'
    },
    {
        name: 'Matthew Flanagan',
        image: '/img/team/MatthewFlanagan1.webp',
        image2: '/img/team/MatthewFlanagan2.webp',
        image3: '/img/team/MatthewFlanagan3.webp',
        title: 'Senior Operations Manager',
        title2: '',
        bio: '<p>Matthew joined the team in 2024, bringing a strong dedication to building relationships and driving success. As a child, he loved the swings, enjoying the carefree moments of flying through the air. An avid runner, Matthew has completed three marathons and eight half-marathons. He cherishes time with his wife and kids, whether watching his daughter play volleyball or his son play baseball or simply being together as a family.</p>'
    },
    {
        name: 'Ashley Jarvis',
        image: '/img/team/ashley1.webp',
        image2: '/img/team/ashley2.webp',
        image3: '/img/team/ashley3.webp',
        title: 'Strategic Account Manager',
        title2: '',
        bio: '<p>Ashley Jarvis has been with the company since 2017. She loves connecting with clients and delivering exceptional service. The swings were her childhood playground favorite. In her free time, she enjoys cheering on the Colts and Pacers, spending time with her two sons, Liam and Lucas, and catching up with friends.</p>'
    },
    {
        name: 'Anna Roberts',
        image: '/img/team/anna-roberts1.webp',
        image2: '/img/team/anna-roberts2.webp',
        image3: '/img/team/anna-roberts3.webp',
        title: 'PE Sales Manager',
        title2: '',
        bio: '<p>Anna Roberts joined NVB in January 2020 and currently serves as a Senior Account Liaison and PE Team Lead. Known for her incredible work ethic and extensive customer service experience, Anna fondly remembers meeting friends at the playground swings during childhood. Outside the office, she enjoys rock collecting, discovering unique plants, and exploring outdoors accompanied by her enthusiastic dog, who happily believes he&apos;s assisting in her adventures.</p>'
    },
    {
        name: 'Valerie Wright',
        image: '/img/team/valerie-wright1.webp',
        image2: '/img/team/valerie-wright2.webp',
        image3: '/img/team/valerie-wright3.webp',
        title: 'Distributor Account Liaison',
        title2: '',
        bio: '<p>Valerie Wright joined NVB in January 2023, and works as a Distributor Account Liaison. Known as the organizational wizard of the PE team, she passionately supports distributors, fosters company growth, and delights in helping customers create perfect play spaces. Valerie fondly recalls childhood playground days spent swinging and exploring large structures. Outside work, she loves discovering new parks and nature spots with her children and enjoys expressing her creativity through cake decorating.</p>'
    },
    {
        name: 'Brad Zmich',
        image: '/img/team/brad-zmich1.webp',
        image2: '/img/team/brad-zmich2.webp',
        image3: '/img/team/brad-zmich3.webp',
        title: 'Senior Account Liaison',
        title2: '',
        bio: '<p>Bradley Zmich joined NVB in July 2021 and works as a Senior Account Liaison. He brings extensive playground knowledge to the team, along with a contagious positivity that boosts coworker morale. Bradley’s fondest childhood memories involve exploring playgrounds and making new friends. Outside of work, he loves attending concerts, camping, hiking adventures with his dogs, and expressing his passion for music through playing drums and DJing.</p>'
    },
    {
        name: 'Michael Nicholas',
        image: '/img/team/michael-nicholas1.webp',
        image2: '/img/team/michael-nicholas2.webp',
        image3: '/img/team/michael-nicholas3.webp',
        title: 'Senior Account Liaison',
        title2: '',
        bio: '<p>Michael Nicholas joined NVB in May 2024 and currently works as a Senior Account Liaison. He contributes a strong work ethic and a consistently positive attitude to the team. Michael fondly recalls childhood memories of spinning as fast as possible on playground merry-go-rounds. Outside of work, he enjoys spending quality time with family and friends, staying active through pickleball, and remaining engaged with his local church community.</p>'
    },
    {
        name: 'Luke Basile',
        image: '/img/team/luke-basile1.webp',
        image2: '/img/team/luke-basile2.webp',
        image3: '/img/team/luke-basile3.webp',
        title: 'Senior Account Liaison',
        title2: '',
        bio: '<p>Luke Basile joined NVB in February 2023 as a Senior Account Liaison. He brings humor, a light-hearted atmosphere, and a knack for viewing challenges from multiple perspectives, enhancing team problem-solving. Childhood playground days spent swinging as high as possible and conquering tall slides remain memorable—ironically shaping his adult acrophobia. Outside work, Luke enjoys writing, refurbishing old furniture, cooking, and binge-watching mystery and true crime series.</p>'
    },
    {
        name: 'Lindsey Reynolds',
        image: '/img/team/LindseyReynolds1.webp',
        image2: '/img/team/LindseyReynolds2.webp',
        image3: '/img/team/LindseyReynolds3.webp',
        title: 'Controller',
        title2: '',
        bio: '<p>Lindsey joined the team in 2024 and brings her expertise in finance and organization to the company. As a child, she loved spending time on the swings, enjoying the simple joys of play. Lindsey cherishes quality time with her kids, whether playing board games or video games. She also finds relaxation in suspense novels and enjoys sharing her musical talents by singing and playing piano at church.</p>'
    },
    {
        name: 'Solo Martin',
        image: '/img/team/solo1.webp',
        image2: '/img/team/solo2.webp',
        image3: '/img/team/solo3.webp',
        title: 'Inbound Warehouse Manager (Indianapolis, IN)',
        title2: '',
        bio: '<p>Since 2021, Solo Martin has been leading the Indianapolis warehouse team with dedication and energy. Growing up, he enjoyed monkey bars, merry-go-rounds, and swings. Solo’s hobbies include landscaping, working out, cooking, and sports.</p>'
    },
    {
        name: 'Ayesha Rauf',
        image: '/img/team/AyeshaRauf1.webp',
        image2: '/img/team/AyeshaRauf2.webp',
        image3: '/img/team/AyeshaRauf3.webp',
        title: 'Marketing Manager',
        title2: '',
        bio: '<p>Ayesha joined the team in 2024, bringing creativity and a strategic mindset to the marketing department. As a child, she loved the thrill of spiral slides, which sparked her sense of adventure. Ayesha enjoys cruising, riding horses, and staying active through fitness activities like going to the gym. She’s also passionate about keeping up with the latest trends and expanding her knowledge across a variety of fields.</p>'
    },
    {
        name: 'Robert Cheezum',
        image: '/img/team/RobertCheezum1.webp',
        image2: '/img/team/RobertCheezum2.webp',
        image3: '/img/team/RobertCheezum3.webp',
        title: 'Design Manager',
        title2: '',
        bio: '<p>Robert joined the team in 2024, bringing a passion for innovation and a keen eye for design. As a child, he loved the monkey bars, embracing the challenge and fun they offered. Outside of work, Robert enjoys building computers, competing in professional poker tournaments, and perfecting his meat-smoking techniques. Above all, he treasures spending quality time with his family, including his children and grandchildren.</p>'
    },
    {
        name: 'Nicolas Moss',
        image: '/img/team/nicolasm1.webp',
        image2: '/img/team/nicolasm2.webp',
        image3: '/img/team/nicolasm3.webp',
        title: 'Training Design Lead',
        title2: '',
        bio: '<p>Since 2021, Nicolas Moss has used his creativity and technical expertise to design effective training programs. As a child, he loved the swings most of all. These days, Nicolas enjoys gaming, technology, attending concerts, and spending time with his cat.</p>'
    },
    {
        name: 'James Brigham',
        image: '/img/team/JamesBrigham1.webp',
        image2: '/img/team/JamesBrigham2.webp',
        image3: '/img/team/JamesBrigham3.webp',
        title: 'Data Manager',
        title2: '',
        bio: '<p>James has been with the team since 2019, bringing expertise in data management and analysis. As a child, he loved the swings, enjoying the freedom and excitement they brought. James is a passionate gamer, with a love for video games, board games, and RPGs. He’s also a cinephile, always seeking out great films, and enjoys experiencing live music whenever possible.</p>'
    },
        {
        name: 'David Perrey',
        image: '/img/team/DavidPerrey1.webp',
        image2: '/img/team/DavidPerrey2.webp',
        image3: '/img/team/DavidPerrey3.webp',
        title: 'Outbound Warehouse Manager (Indianapolis, IN)',
        title2: '',
        bio: '<p>David joined the team in 2024, bringing a strong work ethic and leadership to the warehouse operations. As a child, he was a fan of the monkey bars, always up for the challenge. David is passionate about coaching football and staying active with his kids. Football Sundays with his family are a highlight of his week, especially cheering on the Dolphins. He also enjoys playing card games in his downtime.</p>'
    },
    {
        name: 'Cris Coursen',
        image: '/img/team/CrisCoursen1.webp',
        image2: '/img/team/CrisCoursen2.webp',
        image3: '/img/team/CrisCoursen3.webp',
        title: 'Inbound Warehouse Manager (Savannah, GA)',
        title2: '',
        bio: '<p>Cris joined the team in 2024, bringing a strong focus on efficiency and organization to the inbound warehouse operations. As a child, he loved spending time on the swings, enjoying the sense of freedom. Outside of work, Cris enjoys golfing, trail hiking, and scuba diving. He’s also a passionate college football fan, cheering for Notre Dame.</p>'
    },
    {
        name: 'Richard Russum',
        image: '/img/team/richard1.webp',
        image2: '/img/team/richard2.webp',
        image3: '/img/team/richard3.webp',
        title: 'IT Manager',
        title2: '',
        bio: '<p>Richard Russum has been with the company since 2013, managing IT operations with expertise and innovation. He loved climbing playground equipment as a child. Today, Richard enjoys traveling and discovering new places.</p>'
    },
];

